export default "__VITE_ASSET__DkxdPxIF__"